import React, { Component } from 'react';

class Home extends Component {
    render() {

        return( 

        <h2 className="home"> </h2>
        
        );
        
    }
}

export default Home;